import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconKeyframe"><Path d="M13.9442 2.88407C12.8703 1.81013 11.1291 1.81013 10.0552 2.88406L2.88358 10.0556C1.80964 11.1295 1.80964 12.8708 2.88358 13.9447L10.0551 21.1163C11.1291 22.1902 12.8703 22.1902 13.9442 21.1163L21.1158 13.9447C22.1898 12.8708 22.1898 11.1295 21.1158 10.0556L13.9442 2.88407Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyframe;
